<template>
	<div :class="['eventNotes mb-06', { 'mt-04': isAddingNote || editedNote || notes?.length }]">
		<EditNote v-if="isAddingNote" v-model="upsertedNoteText" class="mb-03" @cancel="cancel()" @save="save" />

		<div class="notes flex flex-col gap-02 overflow-y-auto">
			<template v-for="note in notes" :key="note.id">
				<!-- Editing the note -->
				<EditNote v-if="editedNote === note" v-model="upsertedNoteText" mode="edit" @cancel="cancel()" @save="save" />

				<!-- Deleting the note -->
				<div v-else-if="noteBeingDeleted === note" class="note flex items-start justify-between gap-03 px-04">
					<div class="text font-paragraph-s py-03 text-ink-87">{{ t('eventNotes.deleteNoteConfirmation') }}</div>

					<div class="flex items-center gap-03 py-02">
						<Telemetry name="Cancel deleting event note">
							<Button size="xs" variant="quaternary" @click="cancel()">{{ t('eventNotes.no') }}</Button>
						</Telemetry>

						<Telemetry name="Confirm deleting event note">
							<Button size="xs" variant="quaternary" @click="onConfirmNoteRemoval">{{ t('eventNotes.yes') }}</Button>
						</Telemetry>
					</div>
				</div>

				<!-- Viewing the note -->
				<EventNote
					v-else
					:note="note"
					:editable="!isAddingNote && !editedNote && !noteBeingDeleted"
					@edit="onEditNote(note)"
					@remove="onRemoveNote(note)"
				/>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useTranslation, Button } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import Telemetry from '@/common/components/Telemetry.vue'
import EditNote from '@/features/eventDetails/components/EditNote.vue'
import EventNote from '@/features/eventDetails/components/EventNote.vue'
import { useEventNotesStore } from '@/features/notes/useEventNotesStore'

const { notes, isAddingNote, upsertedNoteText, editedNote, noteBeingDeleted } = storeToRefs(useEventNotesStore())
const { save, cancel, onEditNote, onRemoveNote, onConfirmNoteRemoval } = useEventNotesStore()

const { t } = useTranslation()
</script>

<style lang="scss" scoped>
.eventNotes {
	.note {
		background-color: rgb(from theme('colors.message.info') r g b / 0.12);
	}
}
</style>
